"use client";

import React from "react";
// import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
// import { useLocation } from "react-router";
import "./Header.css";
import { usePathname } from "next/navigation";
import Link from "next/link";
import { useDispatch, useSelector } from "react-redux";
import {
  setInquiryPopup,
  setInquiryPopupObj,
} from "@/store/slices/inquirySlice";
import BottomStrip from "../BottomStrip";
import HeaderContactDropdown from "./HeaderContactDropdown";
import Image from "next/image";

export default function Header({
  //   inquiryPopup,
  //   setInquiryPopup,
  adminDetail,
  propertylist,
  categoryList,
  completedPropertylist,
  pageList,
  socialList,
}) {
  const pathName = usePathname();
  const inquiryPopup = useSelector((state) => state.inquiry.inquiryPopup);
  const inquiryPopupObj = useSelector((state) => state.inquiry.inquiryPopupObj);
  const [openContactDropdown, setOpenContactDropdown] = useState(false);

  const [isMounted, setIsMounted] = useState(false);
  const [isMobileScreen, setMobileScreen] = useState(false);
  //   const [categoryList, setCategoryList] = useState(null);
  const [megaMenuCategory, setMegaMenuCategory] = useState("");
  const [megaMenuActive, setMegaMenuToggle] = useState(false);
  const [menuToggle, setMenuToggle] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (window.innerWidth <= 767) {
      setMobileScreen(true);
    }

    // if (Array.isArray(propertylist)) {
    //   getCategory();
    // }
    setIsMounted(true);
  }, []);

  useEffect(() => {
    setActiveIndex("");
  }, [pathName]);

  const megaMenuClick = (category) => {
    if (megaMenuCategory == category) {
      setMegaMenuCategory("");
      setMegaMenuToggle(false);
    } else {
      setMegaMenuCategory(category);
      setMegaMenuToggle(true);
    }
  };
  const megaMenuClickClose = () => {
    setMegaMenuCategory("");
    setMegaMenuToggle(false);
  };

  if (!categoryList || categoryList.length === 0) return null;

  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setMegaMenuToggle(false);
      setMegaMenuCategory("");
      if (currentScrollY > lastScrollY) {
        setShowNavbar(false); // scrolling down
      } else {
        setShowNavbar(true); // scrolling up
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    const shouldLockScroll = menuToggle;
    // const shouldLockScroll = menuToggle;

    document.body.style.overflow = shouldLockScroll ? "hidden" : "auto";

    if (menuToggle) {
      dispatch(setInquiryPopup(false));
    }

    console.log(menuToggle);
    // console.log(isProximityOpen);

    return () => {
      document.body.style.overflow = "auto"; // cleanup on unmount
    };
  }, [menuToggle]);

  return (
    <>
      <div className={`header-wrapper ${showNavbar ? "" : "webmenu_hidden"}`}>
        <div className="header-flex">
          <div className="header-logo">
            <Link href="/">
              {adminDetail?.logo && (
                <img
                  src={adminDetail.logo}
                  alt={adminDetail.name || "Logo"}
                  fetchPriority="high"
                />
              )}
            </Link>
          </div>
              {/* HeaderLogo added */} 
          <div className="header-links-ul" style={{ minHeight: "1.5rem" }}>
            <ul className="link-font-size">
              {isMounted &&
                categoryList.map((categoryData, index) => (
                  <li
                    key={index}
                    className="hide-tab-mobile"
                    onClick={(e) => {
                      setMenuToggle(false);
                      megaMenuClick(categoryData.category);
                      e.stopPropagation();
                    }}
                  >
                    <div
                      className={
                        megaMenuCategory === categoryData.category
                          ? "a active"
                          : "a"
                      }
                    >
                      <p
                        className={`capitalize ${
                          megaMenuCategory === categoryData.category
                            ? "secondary-color"
                            : ""
                        }`}
                      >
                        {categoryData.category === "Commercial"
                          ? "Offices & Retail"
                          : categoryData.category}
                      </p>

                      {/* {typeof window !== "undefined" && ( */}
                      {/* // <span className="material-symbols-outlined">
                      //   keyboard_arrow_down
                      // </span> */}
                      {/* )} */}
                      <div className="down_arrow">
                        <img src="/images/icon/down_arrow.png" alt="" />
                      </div>
                    </div>
                  </li>
                ))}
              <li className="visible-tab-mobile">
                <div
                  onClick={(e) => {
                    setMenuToggle(false);
                    setOpenContactDropdown(true);
                  }}
                >
                  <img
                    src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/call.svg"
                    alt="Call icon"
                  />
                </div>
              </li>
              <li>
                <div
                  className={`menubar ${menuToggle ? "active" : ""}`}
                  onClick={() => {
                    setMenuToggle(!menuToggle);
                    megaMenuClickClose();
                  }}
                >
                  <div className="bar bar-top"></div>
                  <div className="bar bar-middle"></div>
                  <div className="bar bar-bottom"></div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {megaMenuActive && propertylist.length > 0 && (
          <div className="megamenu-wrapper" id="megamenu-wrapper">
            <div className="megamenugrid">
              <div className="megamenuContent">
                {propertylist.map(
                  (data, index) =>
                    data.category === megaMenuCategory && (
                      <div
                        key={index}
                        className={`megamenuItem relative inner-flex 
                ${pathName === data.slug ? "active" : ""}`}
                      >
                        <Link
                          key={data.project_title}
                          href={`/${data.slug}`}
                          className="inner-flex "
                          onClick={() => {
                            megaMenuClickClose();
                          }}
                        >
                          <div className="relative">
                            <div
                              className="project-img-list overflow relative"
                              style={{ aspectRatio: "1920 / 1500" }}
                            >
                              <Image
                                src={`${data.banner_data.image_web_full}&h=844&w=1080&q=100`}
                                alt={data.project_title || "project"}
                                fill
                                style={{ aspectRatio: "32/25" }}
                              />
                            </div>

                            {data?.status && (
                              <div
                                className={`status-lable status-${data.status
                                  .toLowerCase()
                                  .replace(/\s+/g, "-")
                                  .replace(/[^a-z0-9-]/g, "")}`}
                              >
                                <p className="text-uppercase">{data.status}</p>
                              </div>
                            )}
                          </div>

                          <div className="project-info-list">
                            <div className="inner-flex">
                              <div className="section-paragraph flex-row j-c-sb alc">
                                <h2 className="text-uppercase charter_regular">
                                  {data.project_title}
                                </h2>
                                <div className="project-arrow-icon common-icon">
                                  <img
                                    src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/right_arrow_line.svg"
                                    alt={data.project_title}
                                  />
                                </div>
                              </div>
                              <div className="flex-row flex-wrapgap1 alc inner-flex-smallest">
                                {data.size_price && (
                                  <div
                                    className={`project-information-div flex-row alc inner-flex-smallest ${
                                      isMobileScreen ? "w100" : ""
                                    } `}
                                  >
                                    <div className="building-icon common-icon">
                                      <img
                                        src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/building.svg"
                                        alt="Building Icon"
                                      />
                                    </div>
                                    <div className="section-textpara banner-detail-row-grid-text">
                                      <p className="capitalize ellipsis-1">
                                        {data.size_price}
                                      </p>
                                    </div>
                                  </div>
                                )}

                                {data.location && (
                                  <div
                                    className={`project-information-div flex-row alc inner-flex-smallest ${
                                      isMobileScreen ? "w100" : ""
                                    } `}
                                  >
                                    <div className="building-icon common-icon">
                                      <img
                                        src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/location.svg"
                                        alt="Location Icon"
                                      />
                                    </div>
                                    <div className="section-textpara">
                                      <p className="capitalize ellipsis-1">
                                        {data.location}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ),
                )}
              </div>
            </div>
          </div>
        )}

        {/* {megaMenuActive && <div className={`click-overlay active`}
    onClick={()=>megaMenuClickClose()}></div>} */}

        <div
          className={`click-overlay ${
            megaMenuActive || menuToggle || openContactDropdown ? "active" : ""
          } `}
          onClick={() => {
            megaMenuClickClose();
            setMenuToggle();
            setOpenContactDropdown(false);
          }}
        ></div>

        <div
          className={`mobile_menu_wrapper inner-flex inner-flex-medium j-c-sb  ${
            menuToggle ? "mobileMenuActive" : ""
          } `}
        >
          <div className="header-navigation-links">
            <ul className="">
              {categoryList.map((category_data, index) => (
                <li key={index} className=" accordion-block" id="accordion">
                  <div
                    onClick={() => toggleAccordion(index)}
                    className={`flex-row j-c-sb header_accordion accordion_click  ${
                      activeIndex === index ? "active" : ""
                    } `}
                  >
                    <div className="section-paragraph">
                      <p className="capitalize semibold-fonts">
                        {category_data.category == "Commercial"
                          ? "Offices & Retail"
                          : category_data.category}
                      </p>
                    </div>
                    <div>
                      <img
                        src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/down-arrow.svg"
                        alt=""
                        className="manu-accordian-downarrow"
                      />
                      <img
                        src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/up-arrow.svg"
                        alt=""
                        className="manu-accordian-uparrow"
                      />
                    </div>
                  </div>
                  <div
                    className={`content_accordian_header ${
                      activeIndex === index ? "content_accordianActive" : ""
                    }`}
                  >
                    <div>
                      <div className="inner-flex projectList_li inner-flex-zero">
                        {propertylist != null &&
                          propertylist.length > 0 &&
                          propertylist.map((data, index2) => {
                            if (data.category == category_data.category) {
                              return (
                                <div key={index2}>
                                  <Link
                                    href={`/${data.slug}`}
                                    className="header-hover"
                                    onClick={() => {
                                      setMenuToggle(false);
                                    }}
                                  >
                                    <div className="inner-flex inner-flex-smallest">
                                      <div
                                        className=" w100 relative"
                                        style={{ aspectRatio: "1920 / 1500" }}
                                      >
                                        <Image
                                          src={`${data.banner_data.image_web_full}&h=844&w=1080&q=100`}
                                          alt={data.project_title || "project"}
                                          fill
                                          style={{ aspectRatio: "32/25" }}
                                        />
                                        {data?.status && (
                                          <div
                                            className={`status-lable status-${data.status
                                              .toLowerCase()
                                              .replace(/\s+/g, "-")
                                              .replace(/[^a-z0-9-]/g, "")}`}
                                          >
                                            <p className="text-uppercase">
                                              {data.status}
                                            </p>
                                          </div>
                                        )}
                                      </div>

                                      <div className=" w100 inner-flex inner-flex-smallest">
                                        <div className="section-paragraph">
                                          <p className=" header-title capitalize ">
                                            {data.project_title}
                                          </p>
                                        </div>
                                        <div className="flex-row flex-wrapgap1 flex-row-mobile inner-flex-smallest">
                                          <div className="flex-row alc">
                                            <div className="iconimg">
                                              <img
                                                src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/location.svg"
                                                alt=""
                                              />
                                            </div>
                                            <div className=" section-content">
                                              <span className="ellipsis-1">
                                                {data.location}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="flex-row alc">
                                            <div className="iconimg">
                                              <img
                                                src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/building.svg"
                                                alt=""
                                              />
                                            </div>
                                            <div className=" section-content">
                                              <span className="ellipsis-1">
                                                {data.size_price}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                              );
                            }
                          })}
                        {completedPropertylist != null &&
                          completedPropertylist.length > 0 &&
                          completedPropertylist.map((data, index3) => {
                            if (
                              data.category == category_data.category &&
                              data.project_id == "764"
                            ) {
                              return (
                                <div key={index3}>
                                  <Link
                                    href={`/${data.slug}`}
                                    className="header-hover"
                                    onClick={() => {
                                      setMenuToggle(false);
                                    }}
                                  >
                                    <div className="inner-flex inner-flex-smallest">
                                      <div
                                        className=" w100 relative"
                                        style={{ aspectRatio: "1920 / 1500" }}
                                      >
                                        <Image
                                          src={`${data.banner_data.image_web_full}&h=844&w=1080&q=100`}
                                          alt={data.project_title || "project"}
                                          fill
                                          style={{ aspectRatio: "32/25" }}
                                        />
                                      </div>

                                      {data?.status && (
                                        <div
                                          className={`status-lable status-${data.status
                                            .toLowerCase()
                                            .replace(/\s+/g, "-")
                                            .replace(/[^a-z0-9-]/g, "")}`}
                                        >
                                          <p className="text-uppercase">
                                            {data.status}
                                          </p>
                                        </div>
                                      )}
                                      <div className=" w100 inner-flex inner-flex-smallest">
                                        <div className="section-paragraph">
                                          <p className=" header-title capitalize ">
                                            {data.project_title}
                                          </p>
                                        </div>
                                        <div className="flex-row flex-wrapgap1 flex-row-mobile inner-flex-smallest">
                                          <div className="flex-row alc">
                                            <div className="iconimg">
                                              <img
                                                src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/location.svg"
                                                alt=""
                                              />
                                            </div>
                                            <div className=" section-content">
                                              <span className="ellipsis-1">
                                                {data.location}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="flex-row alc">
                                            <div className="iconimg">
                                              <img
                                                src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/building.svg"
                                                alt=""
                                              />
                                            </div>
                                            <div className=" section-content">
                                              <span className="ellipsis-1">
                                                {data.size_price}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                              );
                            }
                          })}
                      </div>
                    </div>
                  </div>
                </li>
              ))}

              <li>
                <div>
                  <Link
                    href="/completed-projects"
                    className={`capitalize section-paragraph ${
                      pathName == "/completed-projects" ? "active_page" : ""
                    } `}
                    onClick={() => {
                      setMenuToggle(false);
                    }}
                    title="Completed Projects"
                  >
                    <p>Completed Projects</p>
                  </Link>
                </div>
              </li>
              {pageList != null &&
                pageList.length > 0 &&
                pageList.map((data, index) => {
                  if (data.page_type == "" && data.is_profile_page == 0) {
                    return (
                      <li key={index}>
                        <div>
                          <Link
                            href={`/${data.slug}`}
                            className={`capitalize section-paragraph ${
                              pathName == data.slug ? "active_page" : ""
                            } `}
                            onClick={() => {
                              setMenuToggle(false);
                            }}
                            title={data.page_name}
                            target={data.slug_target}
                          >
                            <p>{data.page_name}</p>
                          </Link>
                        </div>
                      </li>
                    );
                  }
                })}
              {socialList != null && socialList.length > 0 && (
                <li className="flex-row alc no-border">
                  {socialList.map((social, index) => (
                    <div className="navigation-mobile-icon" key={index}>
                      {social.name == "facebook" && (
                        <a
                          href={social.slug}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/social-icons/facebook.svg"
                            alt="facebook"
                          />
                        </a>
                      )}
                      {social.name == "instagram" && (
                        <a
                          href={social.slug}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/social-icons/instagram.svg"
                            alt="instagram"
                          />
                        </a>
                      )}
                      {social.name == "twitter" && (
                        <a
                          href={social.slug}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/social-icons/twitter.svg"
                            alt="twitter"
                          />
                        </a>
                      )}
                      {social.name == "linkedin" && (
                        <a
                          href={social.slug}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/social-icons/linkedin.svg"
                            alt="linkedin"
                          />
                        </a>
                      )}
                      {social.name == "youtube" && (
                        <a
                          href={social.slug}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/social-icons/youtube.svg"
                            alt="youtube"
                          />
                        </a>
                      )}
                    </div>
                  ))}
                </li>
              )}
            </ul>
          </div>
          <div className="w100 ">
            <button
              className="reecosys-template-button button-style-secondary w100 "
              onClick={() => {
                setMenuToggle(false);
                dispatch(setInquiryPopup(true));
                if (pathName == "/") {
                  dispatch(setInquiryPopupObj(null));
                }
              }}
            >
              <span className="material-symbols-outlined">chat</span>
              <p className="capitalize">Inquire Now</p>
            </button>
          </div>
        </div>
      </div>
      <BottomStrip
        // isAmenityActive={isAmenityOpen}
        // isProximityActive={isProximityOpen}
        isMobilescreen={isMobileScreen}
        projects_full_list_detail={inquiryPopupObj}
      />
      <HeaderContactDropdown
        isMobilescreen={isMobileScreen}
        openContactDropdown={openContactDropdown}
        setOpenContactDropdown={setOpenContactDropdown}
      />
    </>
  );
}
